import { environment } from '../environments/environment';

const BETA_HOST = 'beta.online.silq.com.au';

/** Local `ng serve` uses the sandbox11 file, so the host is what keeps localhost from reporting. */
export function isSentryEnabled(): boolean {
  const sentry = environment.sentry;
  return !!(
    sentry?.enabled &&
    sentry.dsn &&
    typeof window !== 'undefined' &&
    window.location.hostname === BETA_HOST
  );
}
